<template>
    <div class="saleoutView">
        <vxe-layout-container vertical>
            <vxe-layout-header>
                <vxe-form :data="formData">
                    <vxe-form-item field="fromdate" title="日期从" span="4">
                        <vxe-date-picker v-model="formData.fromdate" placeholder="请选择开始日期" />
                    </vxe-form-item>
                    <vxe-form-item field="enddate" title="日期到" span="4">
                        <vxe-date-picker v-model="formData.enddate" placeholder="请选择结束日期" />
                    </vxe-form-item>
                    <vxe-form-item field="customer" title="客户名称" span="4">
                        <vxe-input v-model="formData.customer" placeholder="请输入客户名称" clearable class="form-input" />
                    </vxe-form-item>
                    <vxe-form-item span="8">
                        <vxe-button type="submit" status="primary" @click="handleSearch">搜索</vxe-button>
                        <vxe-button type="reset" @click="handleReset">重置</vxe-button>
                    </vxe-form-item>
                </vxe-form>
            </vxe-layout-header>
            <vxe-layout-body>
                <vxe-table border show-overflow height="100%" :data="tableData" show-footer ref="tableref" :loading="loading"
                    :expand-config="{
                        expandAll: false,
                        accordion: false,
                        trigger: 'click',
                        lazy: true,
                        async loadMethod({ row }) {
                            return handleExpandChange({ row })
                        }
                    }" :cell-config="{ height: 30 }" :footer-data="footerData">
                   <vxe-column type="seq" width="40" title="序号"></vxe-column>
                    <vxe-column type="expand" width="30">
                        <template  #content="{ row }">


                            <vxe-table :data="row.details"  :cell-config="{ height: 30 }" >
                                <vxe-column type="seq" width="40" title="序号"></vxe-column>
                                <vxe-column field="spbh" title="商品编号" width="120"></vxe-column>
                                <vxe-column field="sP_QM" title="商品全名" min-width="200" show-overflow></vxe-column>
                                <vxe-column field="sP_DW" title="单位" width="80" align="center">
                                    <template #default="{ row }">
                                        <vxe-tag status="primary">{{ row.sP_DW || '-' }}</vxe-tag>
                                    </template>
                                </vxe-column>

                                <vxe-column field="dj" title="单价" width="120" align="right">
                                    <template #default="{ row }">
                                        {{ row.dj ? row.dj.toFixed(2) : '0.00' }}
                                    </template>
                                </vxe-column>
                                <vxe-column field="sl" title="数量" width="100" align="right">
                                    <template #default="{ row }">
                                        {{ row.sl || 0 }}
                                    </template>
                                </vxe-column>
                                <vxe-column field="hj" title="合计金额" width="130" align="right">
                                    <template #default="{ row }">
                                        <span style="color: #409EFF; font-weight: bold;">
                                            {{ row.hj ? row.hj.toFixed(2) : '0.00' }}
                                        </span>
                                    </template>
                                </vxe-column>

                                <vxe-column field="bz" title="备注" min-width="150" show-overflow>
                                    <template #default="{ row }">
                                        {{ row.bz || '-' }}
                                    </template>
                                </vxe-column>
                            </vxe-table>


                        </template>
                    </vxe-column>
                    <vxe-column field="单号" title="单号" width="140"></vxe-column>
                    <vxe-column field="日期" title="日期" width="100">
                        <template #default="{ row }">
                            {{ row.日期 ? new Date(row.日期).toLocaleDateString('zh-CN') : '-' }}
                        </template>
                    </vxe-column> <vxe-column field="客户名称" title="客户名称" width="160"></vxe-column>
                    <vxe-column field="含税" title="含税" width="100">
                        <template #default="{ row }">
                            <vxe-tag :status="row.含税 === '普票' ? 'default' : 'success'">
                                {{ row.含税 || '-' }}
                            </vxe-tag>
                        </template>
                    </vxe-column>
                    <vxe-column field="合计金额" title="合计金额" width="120" align="right">
                        <template #default="{ row }">
                            {{ row.合计金额 ? row.合计金额.toFixed(2) : '0.00' }}
                        </template>
                    </vxe-column>
                    <vxe-column field="发货抬头" title="发货抬头" width="100"></vxe-column>
                    <vxe-column field="经手人" title="经手人" width="70"></vxe-column>

                    <vxe-column field="仓库" title="仓库" width="70"></vxe-column>

                    <vxe-column field="备注" title="备注" min-width="150" show-overflow></vxe-column>
                    <vxe-column field="是否对账" title="是否对账" width="70" align="center">
                        <template #default="{ row }">
                            <vxe-tag :status="row.是否对账 ? 'success' : 'default'">
                                {{ row.是否对账 ? '是' : '否' }}
                            </vxe-tag>
                        </template>
                    </vxe-column>
                    <vxe-column field="状态" title="状态" width="70" align="center">
                        <template #default="{ row }">
                            <vxe-tag :status="row.状态 === '正常' ? 'success' : 'danger'">
                                {{ row.状态 || '-' }}
                            </vxe-tag>
                        </template>
                    </vxe-column>
                    <vxe-column field="本次收款" title="本次收款" width="120" align="right">
                        <template #default="{ row }">
                            {{ row.本次收款 ? row.本次收款.toFixed(2) : '0.00' }}
                        </template>
                    </vxe-column>
                    <vxe-column field="剩余金额" title="剩余金额" width="120" align="right">
                        <template #default="{ row }">
                            {{ row.剩余金额 ? row.剩余金额.toFixed(2) : '0.00' }}
                        </template>
                    </vxe-column>
                    <vxe-column field="优惠金额" title="优惠金额" width="120" align="right">
                        <template #default="{ row }">
                            {{ row.优惠金额 ? row.优惠金额.toFixed(2) : '0.00' }}
                        </template>
                    </vxe-column>
                    <vxe-column title="操作" width="180" fixed="right">
                        <template #default="{ row }">
                            <vxe-button mode="text" status="warning" @click="handleEdit(row)">编辑</vxe-button>
                            <vxe-button mode="text" status="danger" @click="handleDelete(row)">删除</vxe-button>
                        </template>
                    </vxe-column>
                </vxe-table>
            </vxe-layout-body>
        </vxe-layout-container>

    </div>
</template>
<script setup>
import { ref, reactive,markRaw ,onMounted } from 'vue'
import { VxeUI } from 'vxe-pc-ui'
import dayjs from 'dayjs'
import request from '@/request/request.js'
import axios from 'axios'
import {  GetDocDetail ,CeatrandomUUID,DeleteSaleDoc} from '../utils/saleDocHelper'
import { sumRowNum, sumNum } from '../utils/calculate'
import saleoutView from './saleoutView.vue'
import { useTabsStore } from '@/pinia/index'
const loading = ref(false)
const tableData = ref([

])
const tableref = ref()
onMounted(async () => { 
   await handleSearch()
})
const handleDelete = async (row) => {
  try {
    // 1. 使用 await 等待用户点击确认或取消
    const confirmResult = await VxeUI.modal.confirm({
      title: '删除确认',
      // 2. 使用模板字符串正确显示单号
      content: `确定要删除 ${row.单号} 这个销售单吗？`,
      mask: false,
      lockView: false
    });

    // 3. 判断用户是否点击了“确认”（vxe-table 通常返回 'confirm'）
    if (confirmResult === 'confirm') {
      // 4. 执行删除请求
      await DeleteSaleDoc(row.单号);
      
      // 5. 删除成功后的操作，例如提示并刷新表格数据
      VxeUI.modal.message({ content: '删除成功', status: 'success' });
      // 这里可以调用你刷新表格列表的方法，例如：fetchTableData()
      handleSearch();
    }
  } catch (error) {
    // 捕获用户点击取消或网络请求报错的情况
    console.log('用户取消了删除操作或请求发生错误', error);
  }
}
// 展开行事件
// ✅ 使用 async/await，自动返回 Promise
const handleExpandChange = async ({ row }) => {
    try {
        const res = await GetDocDetail(row.单号)
        // 将明细数据存储到行对象中
        row.details = res || []
        return row.details
    } catch (error) {
        console.error('加载明细失败:', error)
        row.details = []
        return []
    }
}
const formData = reactive({
    fromdate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    enddate: dayjs().format('YYYY-MM-DD'),
    customer: '',
})
const handleSearch = async () => {
    try {
    
    loading.value = true
        const res = await request.post('/Saledoc/GetSaleDocs', {
            fromDate: formData.fromdate,
            endDate: formData.enddate,
            customer: formData.customer
        })
        tableData.value = res.data
        updateFootEvent()
        // 调用API搜索
        loading.value = false
    } catch (error) {
        loading.value = false
        VxeUI.modal.message({
            id: 'myUniqueMsg',
            content: error,
            status: 'error'
        })
    }
}

const handleReset = () => {
    formData.fromdate = dayjs().format('YYYY-MM-DD'),
        formData.enddate = dayjs().format('YYYY-MM-DD'),
        formData.customer = ''
}
const handleEdit = (row) => { 
 let SalesOut= {
      name: 'SalesOut',
      title: '销售出库单',
      ID: CeatrandomUUID(),
      closable:true,
      component: markRaw(saleoutView),
      props: {
      initialData: { 
        usefule: '修改', 
        docNumber: row.单号 
      }
    }
}
 // 添加标签页（如果已存在会自动切换到该标签页）
   const tabsStore = useTabsStore()
  tabsStore.addTab(SalesOut, true)
  tabsStore.activeTab = SalesOut.ID
}
// 在值发生改变时更新表尾合计
const updateFootEvent = () => {
    updateFootCount(tableData.value)
}
const updateFootCount = (list) => {
  const [sumNObj] = footerData.value
  sumNObj.合计金额 = sumNum(list, '合计金额')
}
const footerData = ref([{ seq: '合计', 合计金额: '0', total: '0' }])
</script>
<style scoped>
.saleoutView {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.table-wrapper {
    flex: 1;
    min-height: 0;
    margin-top: 10px;
}
</style>